// @flow
import * as React from 'react';
import {
    FormattedMessage, IntlShape, injectIntl, defineMessages, useIntl,
} from 'react-intl';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import { Box } from 'grommet';
import { More } from 'grommet-icons';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import { Switch, useRouteMatch } from 'react-router-dom';
import ProjectsSidePanel, { PROJECT_SIDEPANEL_KEY }
    from 'esm-web-pro/containers/pages/projects/sidepanel/ProjectsSidePanel';
import ProjectsPageDashboard from 'esm-web-pro/containers/pages/projects/dashboard/ProjectsPageDashboard';
import { Route } from 'react-router';

type Props = {
    intl: IntlShape,
}

const messages = defineMessages({
    projects: {
        id: 'sidebar-projects-title',
        defaultMessage: 'Projects',
    },
});

const ProjectsPage = (props: Props) => {
    const match = useRouteMatch();

    const listRef = React.useRef(null);
    const { formatMessage } = useIntl();

    const reloadData = () => {
        if (listRef.current && listRef.current.table.current) {
            listRef.current.table.current.reloadData();
        }
    };

    return (
        <Switch>
            <Route
                path="/projects/:uuid/dashboard"
                render={() => (
                    <ProjectsPageDashboard />
                )}
            />
            <Route
                render={() => (
                    <Box
                        overflow="auto"
                        flex={{ shrink: 0 }}
                    >
                        <ListPage
                            {...props}
                            ref={listRef}
                            match={match}
                            resourceName="projects"
                            title={formatMessage(messages.projects)}
                            permissions={['project.view_project']}
                            createButtonPermissions={['project.add_project']}
                            newObjectLabel={<FormattedMessage id="projects-new-project" defaultMessage="New Project" />}
                            columns={[
                                {
                                    Header: <FormattedMessage
                                        id="name"
                                        defaultMessage="Name"
                                    />,
                                    accessor: 'name',
                                },
                                {
                                    Header: <FormattedMessage
                                        id="type"
                                        defaultMessage="Type"
                                    />,
                                    id: 'type',
                                    accessor: 'type.name',
                                },
                                {
                                    Header: <FormattedMessage
                                        id="project-description"
                                        defaultMessage="Description"
                                    />,
                                    accessor: 'description',
                                },
                                {
                                    actions: [{
                                        label: <FormattedMessage
                                            id="projmanag-counterparties-dashboard"
                                            defaultMessage="Dashboard"
                                        />,
                                        type: 'link',
                                        component: ProjectsPageDashboard,
                                        icon: <More />,
                                        to: '/projects/{uuid}/dashboard/stages',
                                    }, {
                                        label: <FormattedMessage
                                            id="projmanag-counterparties-quickview"
                                            defaultMessage="Quick View"
                                        />,
                                        type: 'quickView',
                                        accessor: 'uuid',
                                        component: ProjectsSidePanel,
                                        resourceName: 'projects',
                                        getTitle: (obj) => obj.name,
                                        panelId: PROJECT_SIDEPANEL_KEY,
                                        reload: reloadData,
                                    }],
                                    Cell: ActionsColumn,
                                    minWidth: 85,
                                },
                            ]}
                            exact
                        />
                    </Box>
                )}
            />
        </Switch>
    );
};

export default injectIntl(ProjectsPage);
